export const mockupsCount = {
  total: 0,
  iOS: 0,
  iPadOS: 0,
  macOS: 0,
  Android: 0,
}
